import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Icon,
  Button,
  Select,
  Input,
  Checkbox,
  message,
  Modal,
  Spin,
} from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import { Translate } from "react-translated";
import AgencyLifeRetirementActivity from "../Dashboard/parts/ea/agency-life-retirement-activity";
import { ALL_ACTIVE_AGENCIES_API_URL, GET_AM_ACTIVE_AGENCIES, IS_USER_EXISTS_API } from "../../utils/Api_enums";
import AgencyModal from "../SuperAdmin/Modals/AgencyModal";
import { debounceQuery, EMAIL_ADDRESS_IS_INVALID, PLEASE_ENTER_A_VALID_EMAIL_ADDRESS, PLEASE_FILL_ALL_REQUIRED_FIELD } from "../../utils/Constants";
import { useBoundStore } from "../../store/useBoundStore";

const Option = Select.Option;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class InviteAgencyManager extends Component {
  state = {
    loading: false,
    agency_id: null,
    loggedin: this.props.auth.user,
    agencies_modal: false,
    agencies_modal_loading: false,
    user: {
      first_name: "",
      last_name: "",
      email: "",
      user_type: "AGENCY_MANAGER",
      jobs: '{"onboarding":false,"life_licensed":false}',
    },
    checkedAgencies: [],
    user_agencies: [],
    agencies: [],
    search: "",
    sortOrders: ""
  };
  componentDidMount = () => {
    let user = useBoundStore.getState().userInfo;

    if (!user) {
      axios.get("/api/user").then((res) => {
        const u = res.data;
        let agency_id = null;
        if (
          u.user_agency_assoc &&
          u.user_agency_assoc.length > 0
        ) {
          agency_id = u.user_agency_assoc[0].agency_id || null;
        }
        this.setState({ agency_id });
      });
    } else {
      const u = user;
      let agency_id = null;
      if (
        u.user_agency_assoc &&
        u.user_agency_assoc.length > 0
      ) {
        agency_id = u.user_agency_assoc[0].agency_id || null;
      }
      this.setState({ agency_id });
    }

    this.loadagency()

    // axios.get("/api/all_active_agencies").then((res) => {
    //   this.setState({
    //     agencies: res.data,
    //   });
    // });
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { agencies, user_agencies, sortOrders } = this.state;
    // if (prevProps.location.state !== this.props.location.state) {
    //   this.loadagency()
    // }

    // Check if user_agencies or sortOrders have changed
    if (
      user_agencies !== prevState.user_agencies ||
      sortOrders !== prevState.sortOrders
    ) {
      if (agencies.length > 0) {
        const updatedAgencies = agencies.map((agency) => ({
          ...agency,
          isChecked: user_agencies.indexOf(agency.id) >= 0,
        }));

        this.setState((prevState) => ({
          ...prevState,
          agencies: updatedAgencies,
        }));
      }
    }


  };

  loadagency = () => {
    this.loadUsers(1);
    this.setState(prevState => ({
      ...prevState,
      loading: true
    }))
    axios.get(ALL_ACTIVE_AGENCIES_API_URL).then((res) => {
      this.setState({
        agencies: res.data
      });
    }).catch((e) => {
      F.log(e);
    }).finally(() => {
      this.setState(prevState => ({
        ...prevState,
        loading: false
      }))
    })
  }

  loadUsers = (page) => {
    const filters = [];
    filters.push({ name: "active", op: "==", val: 1 });
    filters.push({ name: "user_type", op: "==", val: "AGENCY_MANAGER" });

    const searchPurify = F.removeSpecialCharactersFromString(this.state.search);

    if (searchPurify.trim().length > 0) {
      filters.push({
        or: [
          {
            name: "first_name",
            op: "like",
            val: encodeURIComponent("%" + searchPurify + "%")
          },
          {
            name: "last_name",
            op: "like",
            val: encodeURIComponent("%" + searchPurify + "%")
          },
          {
            name: "email",
            op: "like",
            val: encodeURIComponent("%" + searchPurify + "%")
          }
        ]
      });
    }

    const api =
      "/api/users?page=" +
      page +
      '&q={"filters":' +
      JSON.stringify(filters) +
      "}";
    this.setState({ loading: true });
    axios.get(api).then((res) => {
      this.setState({
        loading: false,
        users: res.data.objects,
        page: res.data.page,
        total_pages: res.data.total_pages
      });
    });
  };

  searchUser = (event) => {
    this.setState({ search: event.target.value }, () => {
      debounceQuery(this.loadUsers.bind(this, 1));
    });
  };
  updateField = (name, val) => {
    const { user } = this.state;
    if (name === "jobs") {
      const data = { onboarding: false, life_licensed: false };
      if (val.indexOf("onboarding") >= 0) data.onboarding = true;
      if (val.indexOf("life_licensed") >= 0) data.life_licensed = true;
      val = JSON.stringify(data);
    }
    user[name] = val;
    this.setState({ user });
  };
  // old invite code 
  // invite = () => {
  //   const { user, loggedin, agency_id, checkedAgencies } = this.state;

  //   // F.log("THis.state = > ", this.state)
  //   if (
  //     user.email !== "" &&
  //     user.first_name !== "" &&
  //     user.last_name !== "" &&
  //     checkedAgencies.length > 0
  //   ) {
  //     this.setState({ loading: true });
  //     // F.log("User = > ", user)
  //     axios
  //       .post("/api/is_user_exist", {
  //         email: user.email,
  //       })
  //       .then((res) => {
  //         // F.log("User Exis = >", res.data)
  //         const user_id = res.data;
  //         if (user_id) {
  //           //#region Old Code
  //           // axios.post("/api/user_agency_assoc", {
  //           //     agency_id: agency_id,
  //           //     user_id: user_id
  //           // }).then((res) => {
  //           //     axios.post("/api/associations", {
  //           //         parent_id: loggedin.id,
  //           //         child_id: user_id,
  //           //         status: 1
  //           //     }).then((res) => {
  //           //         message.success(F.translate(`Invite sent successfully`));
  //           //         this.setState({ loading: false }, () => {
  //           //             this.props.history.push('/manage-users');
  //           //         });
  //           //     }).catch(() => {
  //           //         message.error(F.translate(`Invitation not sent`));
  //           //         this.setState({ loading: false });
  //           //     });
  //           // }).catch((res) => {
  //           //     message.error(F.translate(`Invitation not sent, please try again later.`));
  //           //     this.setState({ loading: false });
  //           // });
  //           //#endregion
  //           axios
  //             .post("/api/associations", {
  //               parent_id: loggedin.id,
  //               child_id: user_id,
  //               status: 1,
  //             })
  //             .then((res) => {
  //               message.success(F.translate(`Invite sent successfully`));
  //               this.setState({ loading: false }, () => {
  //                 this.props.history.push("/manage-users");
  //               });
  //             })
  //             .catch(() => {
  //               message.error(F.translate(`Invitation not sent`));
  //               this.setState({ loading: false });
  //             });
  //         } else {
  //           axios
  //             .post("/api/token", {
  //               first_name: user.first_name,
  //               last_name: user.last_name,
  //               email: user.email,
  //               user_type: user.user_type,
  //               invited_by: loggedin.id,
  //             })
  //             .then((res) => {
  //               const user = res.data;
  //               let agency_ids = this.uniqueItems(checkedAgencies);
  //               axios
  //                 .post(`/api/update_am_agency_assoc_multi/${user.id}`, {
  //                   agency_ids,
  //                 })
  //                 .then((res) => {
  //                   message.success(F.translate(`Invite sent successfully`));
  //                   this.setState({ loading: false }, () => {
  //                     this.props.history.push("/manage-users");
  //                   });
  //                 });
  //             })
  //             .catch(() => {
  //               message.error(
  //                 F.translate(`Invitation not sent, please try again later.`)
  //               );
  //             });
  //         }
  //       })
  //       .catch(() => {
  //         message.error(F.translate(`Please try again later.`));
  //         this.setState({ loading: false });
  //       });
  //   } else {
  //     message.error(F.translate(`Please fill all required fields.`));
  //     this.setState({ loading: false });
  //   }
  // };
  invite = () => {
    const { user, loggedin, agency_id, checkedAgencies } = this.state;

    // F.log("THis.state = > ", this.state)

    if (
      user.email !== "" &&
      user.first_name !== "" &&
      user.last_name !== "" &&
      checkedAgencies.length > 0
    ) {

      if (!F.validateEmail(user.email)) {
        message.destroy();
        message.error(
          F.translate(EMAIL_ADDRESS_IS_INVALID)
        );
        return
      } else {
        this.setState({ loading: true });
        // F.log("User = > ", user)

        // F.log("User Exis = >", res.data)
        axios.post(IS_USER_EXISTS_API, {
          email: user.email
        }).then((res) => {
          // console.log("data==>",res.data)
          const { active, exist } = res.data;
          // const user_id = res.data;
          if (exist && active) {
            message.error(F.translate(`A user with this email already exists. Please try again with a different email`));
            return;
            // checking if user already exists with email but currently not active in system 
          } else if (exist && !active) {
            message.error(F.translate(`The user exists with the given email but is currently inactive in the system.`));
            return;
          } else {
            axios
              .post("/api/token", {
                first_name: F.stripHtml(user.first_name),
                last_name: F.stripHtml(user.last_name),
                email: user.email,
                user_type: user.user_type,
                invited_by: loggedin.id,
              })
              .then((res) => {
                const user = res.data;
                let agency_ids = this.uniqueItems(checkedAgencies);
                axios
                  .post(`/api/update_am_agency_assoc_multi/${user.id}`, {
                    agency_ids,
                  })
                  .then((res) => {
                    message.success(F.translate(`Invite sent successfully`));
                    this.setState({ loading: false }, () => {
                      this.props.history.push("/manage-users");
                    });
                  });
              })
              .catch(() => {
                message.error(
                  F.translate(`Invitation not sent, please try again later.`)
                );
              }).finally(() => {
                this.setState({ loading: false })
              })
          }
        }).catch((err) => {
          console.error(err)
        }).finally(() => {
          this.setState({ loading: false })
        })
      }

    } else {
      message.error(F.translate(PLEASE_FILL_ALL_REQUIRED_FIELD));
      this.setState({ loading: false });
    }
  };

  uniqueItems(agencies) {
    // const uniqueNames = [];
    const agencyArray = Array.from(new Set(agencies));
    return agencyArray;
  }
  handleCloseModal = () => {
    this.setState({
      agencies_modal: false
    });
  }

  // updateAgencyAssoc(user_id) {
  //   return this.state.checkedAgencies.map(async (agent) => {
  //     try {
  //       let associations = await axios.post(
  //         "/api/update_am_agency_assoc/" + user_id + "/" + agent + "/" + 1
  //       );
  //     } catch (error) {
  //       F.log("Error in assigning agencies=> ", error);
  //     }
  //   });
  // }

  updateAgencyAssoc = (agency_id, checked) => {
    let checkedAgencies = this.state.checkedAgencies; // NOSONAR
    let user_agencies = this.state.user_agencies
    if (checked) {
      checkedAgencies.push(agency_id)
      user_agencies.push(agency_id)
    } else {
      checkedAgencies = checkedAgencies.filter((item) => item !== agency_id)
      user_agencies = user_agencies.filter((item) => item !== agency_id)
    }

    this.setState({
      checkedAgencies: checkedAgencies,
      user_agencies: [...user_agencies]
    })
  }

  // axios.post("/api/update_am_agency_assoc/" + user_id + "/" + agency_id + "/" + 1).then((res) => {
  //     F.log("agenc associated => ",res.data)
  //     // this.loadUserAgencies(this.state.user.id);
  // }).catch(e){

  // }

  // loadUserAgencies(user_id) {
  //     // this.setState({
  //     //     agencies_modal_loading: true
  //     // });
  //     // axios.get("/api/am_agencies_assoc/" + user_id).then((res) => {
  //     //     var agencies = [];
  //     //     for (let i = 0; i < res.data.length; i++) {
  //     //         const agency = res.data[i];
  //     //         agencies.push(agency.agency_id);
  //     //     }
  //     //     F.log("Agencies = > ",agencies)
  //     //     this.setState({
  //     //         agencies_modal_loading: false,
  //     //         user_agencies: agencies
  //     //     });
  //     // });
  // }
  render() {
    const { loading, user } = this.state;
    const parentInstance = this;
    const updateField = this.updateField;
    const jobs = [];
    if (
      user.user_type === "AGENCY_MANAGER" &&
      user.jobs !== "" &&
      user.jobs !== null
    ) {
      const jobs_json = JSON.parse(user.jobs);
      if (jobs_json.onboarding) {
        jobs.push("onboarding");
      }
      if (jobs_json.life_licensed) {
        jobs.push("life_licensed");
      }
    }

    return (
      <div>
        <Card
          type="inner"
          // title={<Translate text={`Invite Agency Manager`} />}
          title={<React.Fragment><Icon style={{ color: "#1890ff", marginRight: "5px" }} type="user-add" /> <Translate text={` Invite Agency Manager`} /></React.Fragment>}
          loading={loading}
        >
          <div>
            <Row gutter={16}>
              <Col md={6} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`First Name`} />
                    <span className="asteriskIcon">*</span>
                  </label>
                  <Input
                    value={user.first_name}
                    onChange={(e) => updateField("first_name", e.target.value)}
                    maxLength={50}
                  />
                </div>
              </Col>
              <Col md={6} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Last Name`} />
                    <span className="asteriskIcon">*</span>
                  </label>
                  <Input
                    value={user.last_name}
                    onChange={(e) => updateField("last_name", e.target.value)}
                    maxLength={50}
                  />
                </div>
              </Col>
              <Col md={6} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Email`} />
                    <span className="asteriskIcon">*</span>
                  </label>
                  <Input
                    value={user.email}
                    onChange={(e) => updateField("email", e.target.value)}
                  />
                </div>
              </Col>
              <Col md={6} span={24}>
                <div className="inputField">
                  <label>
                    <Translate text={`Enter Agencies`} />
                    <span className="asteriskIcon">*</span>
                  </label>
                  {/* <Input value={user.email} onChange={(e) => updateField('email', e.target.value)} /> */}
                  <Button
                    className="borderRadius-28"
                    onClick={() => {
                      this.setState(
                        {
                          agencies_modal: true,
                          // user
                        }
                        // , () => {
                        //     this.loadUserAgencies(user.id)
                        // }
                      );
                    }}
                  >
                    <Icon type="edit" /> Agencies
                  </Button>
                </div>
              </Col>
            </Row>
            {/* <h3><Translate text={`Select Jobs`} /></h3>
                        <Checkbox.Group value={jobs}
                            style={{ width: '100%' }}
                            onChange={(checkedList) => updateField('jobs', checkedList)}
                        >
                            <Checkbox value="onboarding"><Translate text={`Onboarding`} /></Checkbox>
                            <Checkbox value="life_licensed"><Translate text={`Life Licensed`} /></Checkbox>
                        </Checkbox.Group> */}
          </div>
          <div className="right-align">
            <Button type="primary"
              className="bg-164897 borderRadius-28"
              onClick={this.invite.bind(this)}>
              <Translate text={`Invite User`} />
            </Button>
          </div>
          {/* {this.state.agencies_modal ? (
            <Modal
              title={<Translate text={`Agencies`} />}
              visible={this.state.agencies_modal}
              onCancel={() => this.setState({ agencies_modal: false })}
              footer={
                <div>
                  <Button
                    onClick={() => this.setState({ agencies_modal: false })}
                  >
                    <Translate text={`Cancel`} />
                  </Button>
                </div>
              }
            >
              <div className="formBox">
                {this.state.agencies.map((agency, i) => (
                  <div key={i}>
                    <Checkbox
                      checked={
                        this.state.checkedAgencies.indexOf(agency.id) >= 0
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          this.setState({
                            checkedAgencies: [
                              ...this.state.checkedAgencies,
                              ...[agency.id],
                            ],
                          });
                        } else if (!e.target.checked) {
                          F.log("Unchecked");
                          let index = this.state.checkedAgencies.indexOf(
                            agency.id
                          );
                          this.setState({
                            checkedAgencies: this.state.checkedAgencies.filter(
                              (agent) => {
                                return agent.id === agency.id;
                              }
                            ),
                          });
                        }
                        //     this.state.checkedAgencies = [...this.state.checkedAgencies,...[agency.id]]
                        //  this.updateAgencyAssoc(agency.id, e.target.checked);
                      }}
                    >
                      {agency.name}
                    </Checkbox>
                  </div>
                ))}
              </div>
            </Modal>
          ) : null} */}
          {this.state.agencies_modal ? (
            <AgencyModal
              isVisible={this.state.agencies_modal}
              closeModal={this.handleCloseModal}
              agencies={this.state.agencies}
              user={this.state.user}
              title={<Translate text={`Agency Assignment`} />}
              parentInstance={parentInstance}
              user_agencies={this.state.user_agencies}
              has_user={false}
            />
          ) : null}
        </Card>
      </div>
    );
  }
}

export default InviteAgencyManager;



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/invite-agency-manager.js